module.exports = __webpack_public_path__ + "static/media/rana.442fc479.jpg";